export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: unknown; output: unknown; }
};

export type ActionLabel = {
  __typename?: 'ActionLabel';
  labelId: Scalars['ID']['output'];
  severity: Scalars['Int']['output'];
};

export type ActionLabelInput = {
  labelId: Scalars['ID']['input'];
  severity: Scalars['Int']['input'];
};

export type Actor = {
  __typename?: 'Actor';
  additionalInfo?: Maybe<Array<ActorAdditionalInfo>>;
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  labels?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export type ActorAdditionalInfo = {
  __typename?: 'ActorAdditionalInfo';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AnalyticsCount = {
  __typename?: 'AnalyticsCount';
  count: Scalars['Int']['output'];
  percentage: Scalars['Int']['output'];
};

export type ApiAccessClient = {
  __typename?: 'ApiAccessClient';
  clientIdList: Array<Scalars['String']['output']>;
  providerUrl: Scalars['String']['output'];
};

export type ApiAccessClientInput = {
  clientIdList: Array<Scalars['String']['input']>;
  providerUrl: Scalars['String']['input'];
};

export type ApiSettings = {
  __typename?: 'ApiSettings';
  accessClients: Array<ApiAccessClient>;
  contentTypeTps?: Maybe<ContentTypeTps>;
  costPerAudioHour?: Maybe<Scalars['Float']['output']>;
  maxTps: Scalars['Float']['output'];
  monthlyBudget?: Maybe<Scalars['Float']['output']>;
  numberOfClipsPerHour?: Maybe<Scalars['Float']['output']>;
};

export type ApiSettingsInput = {
  accessClients: Array<ApiAccessClientInput>;
  contentTypeTps?: InputMaybe<ContentTypeTpsInput>;
  maxTps: Scalars['Float']['input'];
  monthlyBudget?: InputMaybe<Scalars['Float']['input']>;
};

export type AuditContentContext = {
  __typename?: 'AuditContentContext';
  communityId?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type AuditDecisionResponse = {
  __typename?: 'AuditDecisionResponse';
  auditItemId: Scalars['String']['output'];
  auditSessionId: Scalars['String']['output'];
  auditorId: Scalars['String']['output'];
  auditorName: Scalars['String']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  correctedLabels: Array<AuditLabel>;
  correctedOcr?: Maybe<Scalars['String']['output']>;
  correctedTranscription?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isCurrentUser: Scalars['Boolean']['output'];
  isSelected: Scalars['Boolean']['output'];
  labelsCorrect?: Maybe<Scalars['Boolean']['output']>;
  languageCorrect?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedAt: Scalars['String']['output'];
  lastModifiedBy: Scalars['String']['output'];
  nonTriggeredPolicyAssessments?: Maybe<Array<PolicyCorrectnessAssessment>>;
  ocrCorrect?: Maybe<Scalars['Boolean']['output']>;
  originalLabels: Array<AuditLabel>;
  policiesCorrect?: Maybe<Scalars['Boolean']['output']>;
  selectedAt?: Maybe<Scalars['String']['output']>;
  selectedBy?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  transcriptionCorrect?: Maybe<Scalars['Boolean']['output']>;
  triggeredPolicyAssessments?: Maybe<Array<PolicyCorrectnessAssessment>>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type AuditDecisionsInput = {
  auditSessionId: Scalars['String']['input'];
};

export type AuditDecisionsResponse = {
  __typename?: 'AuditDecisionsResponse';
  decisions: Array<AuditDecisionResponse>;
};

export type AuditItem = {
  __typename?: 'AuditItem';
  auditSessionId: Scalars['String']['output'];
  contentSnapshot: ContentSnapshot;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  decisionsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  kustoReference: KustoReference;
  lastModifiedAt: Scalars['String']['output'];
  lastModifiedBy: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  selectedDecisionId?: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AuditItemFilterOptions = {
  __typename?: 'AuditItemFilterOptions';
  /** List of distinct labels available for filtering */
  labels: Array<Scalars['String']['output']>;
  /** Multiple decisions status options: single, none, multiple */
  multipleDecisionsOptions: Array<Scalars['String']['output']>;
  /** List of distinct severity levels available for filtering */
  severityLevels: Array<Scalars['Int']['output']>;
  /** List of distinct statuses available for filtering */
  statuses: Array<Scalars['String']['output']>;
};

export type AuditItemWithDecisions = {
  __typename?: 'AuditItemWithDecisions';
  auditSessionId: Scalars['String']['output'];
  contentSnapshot: ContentSnapshot;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  decisions: Array<AuditDecisionResponse>;
  decisionsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  kustoReference: KustoReference;
  lastModifiedAt: Scalars['String']['output'];
  lastModifiedBy: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  selectedDecisionId?: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AuditItemsInput = {
  auditSessionId: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  multipleDecisionsStatus?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  severity?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type AuditItemsResponse = {
  __typename?: 'AuditItemsResponse';
  items: Array<AuditItem>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type AuditLabel = {
  __typename?: 'AuditLabel';
  name: Scalars['String']['output'];
  severity: Scalars['Float']['output'];
};

export type AuditLabelInput = {
  name: Scalars['String']['input'];
  severity: Scalars['Float']['input'];
};

export type AuditReport = {
  __typename?: 'AuditReport';
  auditSessionId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  filters: ReportFilters;
  id: Scalars['ID']['output'];
  lastModifiedAt: Scalars['String']['output'];
  lastModifiedBy: Scalars['String']['output'];
  metrics?: Maybe<ReportMetrics>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AuditSession = {
  __typename?: 'AuditSession';
  auditItemFilterOptions?: Maybe<AuditItemFilterOptions>;
  auditReports: Array<AuditReport>;
  completedAt?: Maybe<Scalars['String']['output']>;
  completedCount: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  datasetComposition?: Maybe<DatasetComposition>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemsCount: Scalars['Int']['output'];
  lastModifiedAt: Scalars['String']['output'];
  lastModifiedBy: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pendingCount: Scalars['Int']['output'];
  sampleParameters: SampleParameters;
  sampleStatistics: SampleStatistics;
  skippedCount: Scalars['Int']['output'];
  stats?: Maybe<AuditSessionStats>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AuditSessionFilterOptions = {
  __typename?: 'AuditSessionFilterOptions';
  contentTypes: Array<Scalars['String']['output']>;
  languages: Array<Scalars['String']['output']>;
  severityLevels: Array<Scalars['Int']['output']>;
  standardLabels: Array<StandardLabel>;
  topics: Array<Scalars['String']['output']>;
};

export type AuditSessionStats = {
  __typename?: 'AuditSessionStats';
  canComplete: Scalars['Boolean']['output'];
  completeCount: Scalars['Int']['output'];
  incompleteCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type AuthProvider = {
  __typename?: 'AuthProvider';
  authServerUrl: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDefaultProvider: Scalars['Boolean']['output'];
  jwksUri?: Maybe<Scalars['String']['output']>;
  lastModifiedAt: Scalars['String']['output'];
  lastModifiedBy: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  providerStatus: Scalars['String']['output'];
  providerUrl?: Maybe<Scalars['String']['output']>;
  responseType: Scalars['String']['output'];
  scopes: Array<Scalars['String']['output']>;
  tokenServerUrl: Scalars['String']['output'];
};

export type AuthProvidersResponse = {
  __typename?: 'AuthProvidersResponse';
  isAdmin: Scalars['Boolean']['output'];
  providers: Array<AuthProvider>;
};

export type AvailablePromptVersions = {
  __typename?: 'AvailablePromptVersions';
  classification: Array<Scalars['String']['output']>;
  moderation: Array<Scalars['String']['output']>;
};

export type CaseFeedbackInput = {
  caseId: Scalars['String']['input'];
  communityId: Scalars['String']['input'];
  feedbackComment?: InputMaybe<Scalars['String']['input']>;
  feedbackLabels: Array<Scalars['String']['input']>;
  subjectId: Scalars['String']['input'];
  topicName: Scalars['String']['input'];
};

export type CaseFeedbackResponse = {
  __typename?: 'CaseFeedbackResponse';
  caseId: Scalars['String']['output'];
  communityId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  feedbackComment?: Maybe<Scalars['String']['output']>;
  feedbackLabels: Array<Scalars['String']['output']>;
  feedbackSource: FeedbackSource;
  id: Scalars['String']['output'];
  lastModifiedAt: Scalars['String']['output'];
  lastModifiedBy: Scalars['String']['output'];
  pk: Scalars['String']['output'];
  subjectId: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  topicName: Scalars['String']['output'];
};

/** Status of a moderation case */
export enum CaseStatus {
  Assigned = 'ASSIGNED',
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type ClassificationLabel = {
  __typename?: 'ClassificationLabel';
  confidence?: Maybe<Scalars['Float']['output']>;
  content_type?: Maybe<Scalars['String']['output']>;
  label_id?: Maybe<Scalars['String']['output']>;
  label_name: Scalars['String']['output'];
  label_num_map: Scalars['Float']['output'];
  label_short_name: Scalars['String']['output'];
  metadata?: Maybe<ClassificationLabelMetadata>;
  scope?: Maybe<ClassificationLabelScope>;
  score?: Maybe<Scalars['Float']['output']>;
  severity: Scalars['Float']['output'];
};

export type ClassificationLabelMetadata = {
  __typename?: 'ClassificationLabelMetadata';
  label_status: Scalars['String']['output'];
  last_modified_at: Scalars['String']['output'];
  policy: Scalars['String']['output'];
};

export type ClassificationLabelScope = {
  __typename?: 'ClassificationLabelScope';
  communities: Array<Scalars['String']['output']>;
  community_groups: Array<Scalars['String']['output']>;
  global: Scalars['Boolean']['output'];
};

export type ClassificationPolicy = {
  __typename?: 'ClassificationPolicy';
  community_id: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  created_by: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  is_enabled: Scalars['Boolean']['output'];
  labels: Array<ClassificationPolicyLabel>;
  last_modified_at: Scalars['String']['output'];
  last_modified_by: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ClassificationPolicyLabel = {
  __typename?: 'ClassificationPolicyLabel';
  label_id: Scalars['String']['output'];
  score_threshold?: Maybe<Scalars['Float']['output']>;
  severity?: Maybe<Scalars['Float']['output']>;
};

export type ClassificationPromptDetails = {
  __typename?: 'ClassificationPromptDetails';
  fileName: Scalars['String']['output'];
  isNew?: Maybe<Scalars['Boolean']['output']>;
  promptVersion: Scalars['String']['output'];
};

export type ClassificationResponse = {
  __typename?: 'ClassificationResponse';
  allLabels: Array<Scalars['String']['output']>;
  audioDurationMs?: Maybe<Scalars['Float']['output']>;
  audioName?: Maybe<Scalars['String']['output']>;
  audioText?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  classificationType: Scalars['String']['output'];
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  contentUrl?: Maybe<Scalars['String']['output']>;
  elapsed?: Maybe<Scalars['Float']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  imageName?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<ClassificationLabel>>;
  language?: Maybe<Scalars['String']['output']>;
  languageDetected?: Maybe<Scalars['String']['output']>;
  latencyMs: Scalars['Float']['output'];
  non_triggered_policies?: Maybe<Array<ClassificationPolicy>>;
  policies?: Maybe<Array<ClassificationPolicy>>;
  responseLabelText: Array<Scalars['String']['output']>;
  responseTier: Array<Scalars['String']['output']>;
  severity?: Maybe<Array<Scalars['String']['output']>>;
  text: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type ClassificationResults = {
  __typename?: 'ClassificationResults';
  categories?: Maybe<Array<Scalars['String']['output']>>;
  classificationType?: Maybe<Scalars['String']['output']>;
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  executionTimeMs?: Maybe<Scalars['Int']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<ContentSearchLabel>>;
  languageClassified?: Maybe<Scalars['String']['output']>;
  languageDetected?: Maybe<Scalars['String']['output']>;
  nonTriggeredPolicies?: Maybe<Array<ContentSearchPolicy>>;
  policies?: Maybe<Array<ContentSearchPolicy>>;
  processingTimeMs?: Maybe<Scalars['Int']['output']>;
  transcript?: Maybe<Scalars['String']['output']>;
  wasTranslated?: Maybe<Scalars['Boolean']['output']>;
};

export type ClassifyContentInput = {
  audioName?: InputMaybe<Scalars['String']['input']>;
  communityId: Scalars['String']['input'];
  imageName?: InputMaybe<Scalars['String']['input']>;
  promptVersion?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ClassifyImageInput = {
  communityId: Scalars['String']['input'];
  imageName: Scalars['String']['input'];
  promptVersion?: InputMaybe<Scalars['String']['input']>;
};

export type ClassifyTextInput = {
  communityId: Scalars['String']['input'];
  imageName?: InputMaybe<Scalars['String']['input']>;
  promptVersion?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CommunitiesResponse = {
  __typename?: 'CommunitiesResponse';
  communities: Array<Community>;
  isAdmin: Scalars['Boolean']['output'];
};

export type Community = {
  __typename?: 'Community';
  actions?: Maybe<Array<SafetyAction>>;
  auditReports?: Maybe<Array<AuditReport>>;
  auditReportsByDateRange: Array<AuditReport>;
  auditSession?: Maybe<AuditSession>;
  auditSessions?: Maybe<Array<AuditSession>>;
  communityGroup?: Maybe<CommunityGroupReference>;
  communityGroupId: Scalars['String']['output'];
  comprehensiveAnalytics: ComprehensiveAnalytics;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  moderationStats?: Maybe<Array<TopicStat>>;
  name: Scalars['String']['output'];
  optionalMetadata: OptionalMetadata;
  policies?: Maybe<Array<Policy>>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  securityGroups?: Maybe<SecurityGroups>;
  superHeroArtUrl?: Maybe<Scalars['String']['output']>;
  topics?: Maybe<Array<Topic>>;
  /** @deprecated Use roles field instead. This field will be removed in a future version. */
  userRole?: Maybe<Scalars['String']['output']>;
  workflowConfigurations?: Maybe<Array<CommunityWorkflowConfiguration>>;
};


export type CommunityAuditReportsArgs = {
  page?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type CommunityAuditReportsByDateRangeArgs = {
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
};


export type CommunityAuditSessionArgs = {
  sessionId: Scalars['ID']['input'];
};


export type CommunityAuditSessionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type CommunityComprehensiveAnalyticsArgs = {
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
};

export type CommunityDisagreement = {
  __typename?: 'CommunityDisagreement';
  communityId: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type CommunityGroup = {
  __typename?: 'CommunityGroup';
  actions?: Maybe<Array<SafetyAction>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  securityGroups?: Maybe<SecurityGroups>;
  topics?: Maybe<Array<Topic>>;
  /** @deprecated Use roles field instead. This field will be removed in a future version. */
  userRole?: Maybe<Scalars['String']['output']>;
  workflowConfigurations?: Maybe<Array<WorkflowConfiguration>>;
};

export type CommunityGroupReference = {
  __typename?: 'CommunityGroupReference';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CommunityGroupWithCommunities = {
  __typename?: 'CommunityGroupWithCommunities';
  communities: Array<GuideCommunity>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use roles field instead. This field will be removed in a future version. */
  userRole?: Maybe<Scalars['String']['output']>;
};

export type CommunityGroupsWithCommunitiesResponse = {
  __typename?: 'CommunityGroupsWithCommunitiesResponse';
  communityGroups: Array<CommunityGroupWithCommunities>;
  isAdmin: Scalars['Boolean']['output'];
};

export type CommunityMetrics = {
  __typename?: 'CommunityMetrics';
  communityId: Scalars['String']['output'];
  metrics: MetricsGroup;
};

export type CommunityOptions = {
  __typename?: 'CommunityOptions';
  contentGenres: Array<ContentGenre>;
  pgRatings: Array<ContentRating>;
};

export type CommunityPrompt = {
  __typename?: 'CommunityPrompt';
  availablePromptVersions: AvailablePromptVersions;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastModifiedAt: Scalars['String']['output'];
  lastModifiedBy: Scalars['String']['output'];
  prodPromptVersion: ProdPromptVersion;
  type: Scalars['String']['output'];
};

export type CommunityPromptDetailsResponse = {
  __typename?: 'CommunityPromptDetailsResponse';
  prompt: Scalars['String']['output'];
};

export type CommunityWorkflowConfiguration = {
  __typename?: 'CommunityWorkflowConfiguration';
  apiSettings: ApiSettings;
  topicActions: Array<TopicAction>;
  type: Scalars['String']['output'];
};

export type CompleteAuditSessionResponse = {
  __typename?: 'CompleteAuditSessionResponse';
  completedAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ComplianceReporting = {
  __typename?: 'ComplianceReporting';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CompositionEntry = {
  __typename?: 'CompositionEntry';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export type ComprehensiveAnalytics = {
  __typename?: 'ComprehensiveAnalytics';
  auditSessions: Scalars['Int']['output'];
  confidence?: Maybe<Scalars['String']['output']>;
  decisionAnalysis: DecisionAnalysis;
  itemsAudited: Scalars['Int']['output'];
  labelAnalysis: LabelAnalysis;
  lastAuditDate?: Maybe<Scalars['String']['output']>;
  performanceMetrics: PerformanceMetrics;
  totalReports: Scalars['Int']['output'];
};

export type Content = {
  __typename?: 'Content';
  contentId: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  data: Scalars['String']['output'];
  humanModerationViewHeader?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<ContentLabel>>;
};

export type ContentGenre = {
  __typename?: 'ContentGenre';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ContentLabel = {
  __typename?: 'ContentLabel';
  labels: Array<LabelConfidence>;
  metadata?: Maybe<LabelMetadata>;
  source?: Maybe<Scalars['String']['output']>;
};

export type ContentMetadata = {
  __typename?: 'ContentMetadata';
  audioFileUrl?: Maybe<Scalars['String']['output']>;
  contentUrl?: Maybe<Scalars['String']['output']>;
  customValues?: Maybe<Scalars['JSON']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  subjectId?: Maybe<Scalars['String']['output']>;
  subjectOwner?: Maybe<SubjectOwner>;
};

export type ContentRating = {
  __typename?: 'ContentRating';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ContentRatingDetails = {
  __typename?: 'ContentRatingDetails';
  description: Scalars['String']['output'];
  descriptors: Array<Scalars['String']['output']>;
  interactiveElements: Array<Scalars['String']['output']>;
  ratingId: Scalars['String']['output'];
  ratingSystem: Scalars['String']['output'];
  ratingUrl?: Maybe<Scalars['String']['output']>;
  ratingValue: Scalars['String']['output'];
};

export type ContentSearchContextInput = {
  communityId: Scalars['String']['input'];
  messagesAfter?: Scalars['Float']['input'];
  messagesBefore?: Scalars['Float']['input'];
  metadataFilters: Scalars['JSON']['input'];
  subjectId: Scalars['String']['input'];
  topicName: Scalars['String']['input'];
};

export type ContentSearchInput = {
  communityId: Scalars['String']['input'];
  contentType?: InputMaybe<Array<Scalars['String']['input']>>;
  endTimestamp?: InputMaybe<Scalars['String']['input']>;
  isSampled?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  languageDetected?: InputMaybe<Scalars['String']['input']>;
  maxResultsPerBatch?: InputMaybe<Scalars['Int']['input']>;
  metadataFilters?: InputMaybe<Scalars['JSON']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  startTimestamp?: InputMaybe<Scalars['String']['input']>;
  subjectId?: InputMaybe<Scalars['String']['input']>;
  topicName?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  violatesPolicy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentSearchLabel = {
  __typename?: 'ContentSearchLabel';
  contentType?: Maybe<Scalars['String']['output']>;
  labelId?: Maybe<Scalars['String']['output']>;
  labelName: Scalars['String']['output'];
  labelNumMap: Scalars['Float']['output'];
  labelShortName: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  severity: Scalars['Float']['output'];
};

export type ContentSearchPagination = {
  __typename?: 'ContentSearchPagination';
  batchSize: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  nextSkip?: Maybe<Scalars['Int']['output']>;
  skip: Scalars['Int']['output'];
};

export type ContentSearchPolicy = {
  __typename?: 'ContentSearchPolicy';
  communityId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  labels: Array<PolicyLabel>;
  lastModifiedAt: Scalars['String']['output'];
  lastModifiedBy: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ContentSearchResponse = {
  __typename?: 'ContentSearchResponse';
  executionTimeMs: Scalars['Int']['output'];
  pagination: ContentSearchPagination;
  results: Array<ContentSearchResultItem>;
  totalCount: Scalars['Int']['output'];
};

export type ContentSearchResultItem = {
  __typename?: 'ContentSearchResultItem';
  classificationResults: ClassificationResults;
  communityId: Scalars['String']['output'];
  contentMetadata: ContentMetadata;
  contentType: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSampled: Scalars['Boolean']['output'];
  topicName: Scalars['String']['output'];
};

export type ContentSnapshot = {
  __typename?: 'ContentSnapshot';
  audioFileUrl?: Maybe<Scalars['String']['output']>;
  classificationResults?: Maybe<Array<AuditLabel>>;
  classificationType?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  contentUrl?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  nonTriggeredPolicies?: Maybe<Array<Policy>>;
  quicktxtModelVersion?: Maybe<Scalars['String']['output']>;
  slmModelVersion?: Maybe<Scalars['String']['output']>;
  slmPromptVersion?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['String']['output']>;
  triggeredPolicies?: Maybe<Array<Policy>>;
};

/** The type of content the label applies to */
export enum ContentType {
  Image = 'Image',
  Text = 'Text'
}

export type ContentTypeTps = {
  __typename?: 'ContentTypeTps';
  audio?: Maybe<Scalars['Float']['output']>;
  image?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['Float']['output']>;
};

export type ContentTypeTpsInput = {
  audio?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<Scalars['Float']['input']>;
  text?: InputMaybe<Scalars['Float']['input']>;
};

export type ContextItem = {
  __typename?: 'ContextItem';
  author?: Maybe<Actor>;
  contentId: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  data: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type ConversationContext = {
  __typename?: 'ConversationContext';
  postConversation?: Maybe<Array<ContextItem>>;
  preConversation?: Maybe<Array<ContextItem>>;
};

export type ConversationContextResponse = {
  __typename?: 'ConversationContextResponse';
  followingMessages: Array<ContentSearchResultItem>;
  precedingMessages: Array<ContentSearchResultItem>;
  targetFound: Scalars['Boolean']['output'];
  targetSubjectId: Scalars['String']['output'];
  targetTimestamp: Scalars['String']['output'];
};

export type CreateAuditSessionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sampleParameters: SampleParametersInput;
};

export type CreateCommunityGroupInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  securityGroups?: InputMaybe<SecurityGroupsInput>;
};

export type CreateCommunityInput = {
  communityGroupId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  optionalMetadata?: InputMaybe<OptionalMetadataInput>;
  securityGroups?: InputMaybe<SecurityGroupsInput>;
};

export type CreateCustomLabelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  labelType?: InputMaybe<LabelType>;
  name: Scalars['String']['input'];
};

export type CreatePolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  labels: Array<PolicyLabelInput>;
  name: Scalars['String']['input'];
  workflowType: Scalars['String']['input'];
};

export type CreateStandardLabelInput = {
  contentType?: InputMaybe<ContentType>;
  labelName: Scalars['String']['input'];
  labelNumMap: Scalars['Float']['input'];
  labelShortName?: InputMaybe<Scalars['String']['input']>;
  policy: Scalars['String']['input'];
  scope: LabelScopeInput;
};

export type CreateStandardPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  labels: Array<PolicyLabelInput>;
  name: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  sourcePolicyId?: InputMaybe<Scalars['String']['input']>;
};

export type CustomLabel = {
  __typename?: 'CustomLabel';
  active: Scalars['Boolean']['output'];
  communityId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  labelType: LabelType;
  lastModifiedAt: Scalars['String']['output'];
  lastModifiedBy: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CustomLabelResponse = {
  __typename?: 'CustomLabelResponse';
  label: CustomLabel;
};

export type CustomLabelsResponse = {
  __typename?: 'CustomLabelsResponse';
  labels: Array<CustomLabel>;
};

export type CustomValue = {
  __typename?: 'CustomValue';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DatasetComposition = {
  __typename?: 'DatasetComposition';
  byLabel: Array<CompositionEntry>;
  byLanguage: Array<CompositionEntry>;
  bySeverity: Array<CompositionEntry>;
  byTopic: Array<CompositionEntry>;
  totalItems: Scalars['Int']['output'];
};

export type DecisionAnalysis = {
  __typename?: 'DecisionAnalysis';
  conflicts: AnalyticsCount;
  skipped: AnalyticsCount;
};

export type DeleteAuditDecisionInput = {
  auditItemId: Scalars['ID']['input'];
  auditSessionId: Scalars['ID']['input'];
  decisionId: Scalars['ID']['input'];
};

export type DeleteAuditDecisionResponse = {
  __typename?: 'DeleteAuditDecisionResponse';
  auditItem: AuditItemWithDecisions;
};

export type DeleteAuditSessionInput = {
  sessionId: Scalars['String']['input'];
};

export type DeleteCommunityPromptInput = {
  promptVersion?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCommunityPromptResponse = {
  __typename?: 'DeleteCommunityPromptResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteCommunityResponse = {
  __typename?: 'DeleteCommunityResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeletePolicyInput = {
  policyId: Scalars['ID']['input'];
};

export type DeleteResponse = {
  __typename?: 'DeleteResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteStandardPolicyInput = {
  policyId: Scalars['ID']['input'];
};

export type DeliverySettings = {
  __typename?: 'DeliverySettings';
  postPayload?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type DeliverySettingsInput = {
  postPayload?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DisagreementMetrics = {
  __typename?: 'DisagreementMetrics';
  byCommunity?: Maybe<Array<CommunityDisagreement>>;
  count: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
};

export type FeedbackSource = {
  __typename?: 'FeedbackSource';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GenerateCommunityPromptsInput = {
  labelFeedback?: InputMaybe<Array<LabelFeedbackInput>>;
};

export type GenerateCommunityPromptsResponse = {
  __typename?: 'GenerateCommunityPromptsResponse';
  classification: ClassificationPromptDetails;
  classificationFileName: Scalars['String']['output'];
  moderation: ModerationPromptDetails;
  moderationFileName: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GeneratedPrompt = {
  __typename?: 'GeneratedPrompt';
  availablePromptVersions?: Maybe<AvailablePromptVersions>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  prodPromptVersion?: Maybe<ProdPromptVersion>;
  prompt: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GetCommunityPromptDetailsInput = {
  promptVersion?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GetStandardPoliciesInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideCommunity = {
  __typename?: 'GuideCommunity';
  communityGroupId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  optionalMetadata?: Maybe<OptionalMetadata>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use roles field instead. This field will be removed in a future version. */
  userRole?: Maybe<Scalars['String']['output']>;
};

export type KustoReference = {
  __typename?: 'KustoReference';
  communityId: Scalars['String']['output'];
  subjectId: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type LabelAnalysis = {
  __typename?: 'LabelAnalysis';
  additionalLabels: AnalyticsCount;
  bothMissingAndAdditional: AnalyticsCount;
  exactMatches: AnalyticsCount;
  missingLabels: AnalyticsCount;
};

export type LabelComparisonMetrics = {
  __typename?: 'LabelComparisonMetrics';
  additionalLabelsCount: Scalars['Int']['output'];
  additionalLabelsPercentage: Scalars['Float']['output'];
  bothMissingAndAdditionalCount: Scalars['Int']['output'];
  bothMissingAndAdditionalPercentage: Scalars['Float']['output'];
  exactMatchCount: Scalars['Int']['output'];
  exactMatchPercentage: Scalars['Float']['output'];
  labelsMissingCount: Scalars['Int']['output'];
  labelsMissingPercentage: Scalars['Float']['output'];
};

export type LabelConfidence = {
  __typename?: 'LabelConfidence';
  confidence: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type LabelFeedbackInput = {
  falseNegatives?: InputMaybe<Array<Scalars['String']['input']>>;
  falsePositives?: InputMaybe<Array<Scalars['String']['input']>>;
  labelName: Scalars['String']['input'];
};

export type LabelMetadata = {
  __typename?: 'LabelMetadata';
  explanation?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<LabelUsage>;
};

export type LabelMetrics = {
  __typename?: 'LabelMetrics';
  label: Scalars['String']['output'];
  metrics: MetricsGroup;
};

export type LabelPolicyContent = {
  __typename?: 'LabelPolicyContent';
  content: Scalars['String']['output'];
  labelId: Scalars['ID']['output'];
  lastModified: Scalars['String']['output'];
  policyFile: Scalars['String']['output'];
};

export type LabelScope = {
  __typename?: 'LabelScope';
  communities: Array<Scalars['String']['output']>;
  communityGroups: Array<Scalars['String']['output']>;
  global: Scalars['Boolean']['output'];
};

export type LabelScopeInput = {
  communities?: Array<Scalars['String']['input']>;
  communityGroups?: Array<Scalars['String']['input']>;
  global: Scalars['Boolean']['input'];
};

/** The type of label (moderation or classification) */
export enum LabelType {
  Classification = 'Classification',
  Moderation = 'Moderation'
}

export type LabelUsage = {
  __typename?: 'LabelUsage';
  completionTokens: Scalars['Float']['output'];
  promptTokens: Scalars['Float']['output'];
  totalTokens: Scalars['Float']['output'];
};

export type MetadataDiscoveryInput = {
  communityId: Scalars['String']['input'];
};

export type MetadataDiscoveryResponse = {
  __typename?: 'MetadataDiscoveryResponse';
  analysisEndTime: Scalars['String']['output'];
  analysisStartTime: Scalars['String']['output'];
  communityId: Scalars['String']['output'];
  executionTimeMs: Scalars['Int']['output'];
  metadataKeys: Scalars['JSON']['output'];
  totalRecordsAnalyzed: Scalars['Int']['output'];
};

export type MetricsGroup = {
  __typename?: 'MetricsGroup';
  accuracy: Scalars['Float']['output'];
  f1Score: Scalars['Float']['output'];
  labelCorrectnessCount?: Maybe<Scalars['Int']['output']>;
  labelCorrectnessPercentage?: Maybe<Scalars['Float']['output']>;
  policyCorrectnessCount?: Maybe<Scalars['Int']['output']>;
  policyCorrectnessPercentage?: Maybe<Scalars['Float']['output']>;
  precision: Scalars['Float']['output'];
  recall: Scalars['Float']['output'];
};

export type ModerationCase = {
  __typename?: 'ModerationCase';
  caseId: Scalars['String']['output'];
  communityId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastModifiedAt: Scalars['String']['output'];
  lastModifiedBy: Scalars['String']['output'];
  pk: Scalars['String']['output'];
  report: ModerationReport;
  status: CaseStatus;
  subjectId: Scalars['String']['output'];
  topicName: Scalars['String']['output'];
};

export type ModerationPromptDetails = {
  __typename?: 'ModerationPromptDetails';
  fileName: Scalars['String']['output'];
  isNew?: Maybe<Scalars['Boolean']['output']>;
  promptVersion: Scalars['String']['output'];
};

export type ModerationReport = {
  __typename?: 'ModerationReport';
  communityId: Scalars['String']['output'];
  complianceReporting?: Maybe<Array<ComplianceReporting>>;
  contents?: Maybe<Array<Content>>;
  context?: Maybe<ConversationContext>;
  customValues?: Maybe<Array<CustomValue>>;
  moderationView?: Maybe<ModerationView>;
  reportContext?: Maybe<Array<Scalars['String']['output']>>;
  reportSource?: Maybe<Actor>;
  subjectId: Scalars['String']['output'];
  subjectOwner?: Maybe<Actor>;
  timestamp: Scalars['String']['output'];
  topicName: Scalars['String']['output'];
};

export type ModerationView = {
  __typename?: 'ModerationView';
  contentOrder?: Maybe<Array<Scalars['String']['output']>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  classifyAudio: ClassificationResponse;
  classifyContent: ClassificationResponse;
  classifyImage: ClassificationResponse;
  classifyText: ClassificationResponse;
  completeAuditSession: CompleteAuditSessionResponse;
  createAuditSession: AuditSession;
  createCommunity: Community;
  createCommunityGroup: CommunityGroup;
  createCustomLabel: CustomLabelResponse;
  createPolicy: Policy;
  createSession: SessionMutationResponse;
  createStandardLabel: StandardLabelResponse;
  createStandardPolicy: Policy;
  deleteAuditDecision: DeleteAuditDecisionResponse;
  deleteAuditSession: Scalars['Boolean']['output'];
  deleteCommunity: DeleteCommunityResponse;
  deleteCommunityAction: Scalars['Boolean']['output'];
  deleteCommunityGroup: DeleteCommunityResponse;
  deleteCommunityGroupAction: Scalars['Boolean']['output'];
  deleteCommunityGroupTopic: Scalars['Boolean']['output'];
  deleteCommunityGroupWorkflowConfiguration: Scalars['Boolean']['output'];
  deleteCommunityPrompt: DeleteCommunityPromptResponse;
  deleteCommunityTopic: Scalars['Boolean']['output'];
  deleteCommunityWorkflowConfiguration: Scalars['Boolean']['output'];
  deleteCustomLabel: DeleteResponse;
  deletePolicy: Scalars['Boolean']['output'];
  deleteStandardLabel: DeleteResponse;
  deleteStandardPolicy: Scalars['Boolean']['output'];
  generateAuditReport: AuditReport;
  generateCommunityPrompts: GenerateCommunityPromptsResponse;
  logout: SessionMutationResponse;
  selectAuditDecision: SelectAuditDecisionResponse;
  skipAuditItem: SkipAuditItemResponse;
  submitCaseFeedback: CaseFeedbackResponse;
  unskipAuditItem: SkipAuditItemResponse;
  updateCommunity: Community;
  updateCommunityGroup: CommunityGroup;
  updateCustomLabel: CustomLabelResponse;
  updateLabelPolicyContent: UpdateLabelPolicyContentResponse;
  updatePolicy: Policy;
  updatePromptProdVersion: UpdatePromptProdVersionResponse;
  updateStandardLabel: StandardLabelResponse;
  updateStandardPolicy: Policy;
  upsertAuditDecision: UpsertAuditDecisionResponse;
  upsertCommunityAction: SafetyAction;
  upsertCommunityGroupAction: SafetyAction;
  upsertCommunityGroupTopic: Topic;
  upsertCommunityGroupWorkflowConfiguration: WorkflowConfiguration;
  upsertCommunityTopic: Topic;
  upsertCommunityWorkflowConfiguration: CommunityWorkflowConfiguration;
};


export type MutationClassifyAudioArgs = {
  input: ClassifyContentInput;
};


export type MutationClassifyContentArgs = {
  input: ClassifyContentInput;
};


export type MutationClassifyImageArgs = {
  input: ClassifyImageInput;
};


export type MutationClassifyTextArgs = {
  input: ClassifyTextInput;
};


export type MutationCompleteAuditSessionArgs = {
  sessionId: Scalars['ID']['input'];
};


export type MutationCreateAuditSessionArgs = {
  input: CreateAuditSessionInput;
};


export type MutationCreateCommunityArgs = {
  input: CreateCommunityInput;
};


export type MutationCreateCommunityGroupArgs = {
  input: CreateCommunityGroupInput;
};


export type MutationCreateCustomLabelArgs = {
  communityId: Scalars['ID']['input'];
  input: CreateCustomLabelInput;
};


export type MutationCreatePolicyArgs = {
  communityId: Scalars['ID']['input'];
  input: CreatePolicyInput;
};


export type MutationCreateSessionArgs = {
  providerId: Scalars['String']['input'];
  tokens: TokenInput;
};


export type MutationCreateStandardLabelArgs = {
  input: CreateStandardLabelInput;
};


export type MutationCreateStandardPolicyArgs = {
  input: CreateStandardPolicyInput;
};


export type MutationDeleteAuditDecisionArgs = {
  input: DeleteAuditDecisionInput;
};


export type MutationDeleteAuditSessionArgs = {
  input: DeleteAuditSessionInput;
};


export type MutationDeleteCommunityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCommunityActionArgs = {
  actionName: Scalars['String']['input'];
  communityId: Scalars['ID']['input'];
};


export type MutationDeleteCommunityGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCommunityGroupActionArgs = {
  actionName: Scalars['String']['input'];
  communityGroupId: Scalars['ID']['input'];
};


export type MutationDeleteCommunityGroupTopicArgs = {
  communityGroupId: Scalars['ID']['input'];
  topicName: Scalars['String']['input'];
};


export type MutationDeleteCommunityGroupWorkflowConfigurationArgs = {
  communityGroupId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type MutationDeleteCommunityPromptArgs = {
  communityId: Scalars['ID']['input'];
  input: DeleteCommunityPromptInput;
};


export type MutationDeleteCommunityTopicArgs = {
  communityId: Scalars['ID']['input'];
  topicName: Scalars['String']['input'];
};


export type MutationDeleteCommunityWorkflowConfigurationArgs = {
  communityId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type MutationDeleteCustomLabelArgs = {
  communityId: Scalars['ID']['input'];
  labelId: Scalars['ID']['input'];
};


export type MutationDeletePolicyArgs = {
  communityId: Scalars['ID']['input'];
  input: DeletePolicyInput;
};


export type MutationDeleteStandardLabelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStandardPolicyArgs = {
  input: DeleteStandardPolicyInput;
};


export type MutationGenerateAuditReportArgs = {
  sessionId: Scalars['ID']['input'];
};


export type MutationGenerateCommunityPromptsArgs = {
  communityId: Scalars['ID']['input'];
  input: GenerateCommunityPromptsInput;
};


export type MutationSelectAuditDecisionArgs = {
  input: SelectAuditDecisionInput;
};


export type MutationSkipAuditItemArgs = {
  input: SkipAuditItemInput;
};


export type MutationSubmitCaseFeedbackArgs = {
  input: CaseFeedbackInput;
};


export type MutationUnskipAuditItemArgs = {
  input: UnskipAuditItemInput;
};


export type MutationUpdateCommunityArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCommunityInput;
};


export type MutationUpdateCommunityGroupArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCommunityGroupInput;
};


export type MutationUpdateCustomLabelArgs = {
  communityId: Scalars['ID']['input'];
  input: UpdateCustomLabelInput;
  labelId: Scalars['ID']['input'];
};


export type MutationUpdateLabelPolicyContentArgs = {
  content: Scalars['String']['input'];
  labelId: Scalars['ID']['input'];
};


export type MutationUpdatePolicyArgs = {
  communityId: Scalars['ID']['input'];
  input: UpdatePolicyInput;
  policyId: Scalars['ID']['input'];
};


export type MutationUpdatePromptProdVersionArgs = {
  communityId: Scalars['ID']['input'];
  input: UpdatePromptProdVersionInput;
};


export type MutationUpdateStandardLabelArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStandardLabelInput;
};


export type MutationUpdateStandardPolicyArgs = {
  input: UpdateStandardPolicyInput;
  policyId: Scalars['ID']['input'];
};


export type MutationUpsertAuditDecisionArgs = {
  input: UpsertAuditDecisionInput;
};


export type MutationUpsertCommunityActionArgs = {
  actionName: Scalars['String']['input'];
  communityId: Scalars['ID']['input'];
  input: UpsertActionInput;
};


export type MutationUpsertCommunityGroupActionArgs = {
  actionName: Scalars['String']['input'];
  communityGroupId: Scalars['ID']['input'];
  input: UpsertActionInput;
};


export type MutationUpsertCommunityGroupTopicArgs = {
  communityGroupId: Scalars['ID']['input'];
  input: UpsertTopicInput;
  topicName: Scalars['String']['input'];
};


export type MutationUpsertCommunityGroupWorkflowConfigurationArgs = {
  communityGroupId: Scalars['ID']['input'];
  input: UpsertCommunityGroupWorkflowConfigurationInput;
  type: Scalars['String']['input'];
};


export type MutationUpsertCommunityTopicArgs = {
  communityId: Scalars['ID']['input'];
  input: UpsertTopicInput;
  topicName: Scalars['String']['input'];
};


export type MutationUpsertCommunityWorkflowConfigurationArgs = {
  communityId: Scalars['ID']['input'];
  input: UpsertCommunityWorkflowConfigurationInput;
  type: Scalars['String']['input'];
};

export type OptionalMetadata = {
  __typename?: 'OptionalMetadata';
  bigId?: Maybe<Scalars['String']['output']>;
  contentGenres: Array<Scalars['String']['output']>;
  contentRating?: Maybe<ContentRatingDetails>;
  contentStandardsUrl?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  pgRating: Scalars['String']['output'];
};

export type OptionalMetadataInput = {
  bigId?: InputMaybe<Scalars['String']['input']>;
  contentGenres?: InputMaybe<Array<Scalars['String']['input']>>;
  contentStandardsUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  pgRating?: InputMaybe<Scalars['String']['input']>;
};

export type PerformanceMetrics = {
  __typename?: 'PerformanceMetrics';
  avgAccuracy?: Maybe<Scalars['Float']['output']>;
  avgF1Score?: Maybe<Scalars['Float']['output']>;
  avgPrecision?: Maybe<Scalars['Float']['output']>;
  avgRecall?: Maybe<Scalars['Float']['output']>;
};

export type PoliciesResponse = {
  __typename?: 'PoliciesResponse';
  policies: Array<Policy>;
};

export type Policy = {
  __typename?: 'Policy';
  communityId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isSystemManaged?: Maybe<Scalars['Boolean']['output']>;
  labels: Array<PolicyLabel>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  scope?: Maybe<Scalars['String']['output']>;
  sourcePolicyId?: Maybe<Scalars['String']['output']>;
  workflowType?: Maybe<Scalars['String']['output']>;
};

export type PolicyCorrectnessAssessment = {
  __typename?: 'PolicyCorrectnessAssessment';
  comments?: Maybe<Scalars['String']['output']>;
  isCorrect: Scalars['Boolean']['output'];
  policyId: Scalars['ID']['output'];
  policyName: Scalars['String']['output'];
};

export type PolicyCorrectnessAssessmentInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  isCorrect: Scalars['Boolean']['input'];
  policyId: Scalars['ID']['input'];
  policyName: Scalars['String']['input'];
};

export type PolicyLabel = {
  __typename?: 'PolicyLabel';
  labelId: Scalars['ID']['output'];
  scoreThreshold?: Maybe<Scalars['Float']['output']>;
  severity?: Maybe<Scalars['Int']['output']>;
};

export type PolicyLabelInput = {
  labelId: Scalars['ID']['input'];
  scoreThreshold?: InputMaybe<Scalars['Float']['input']>;
  severity?: InputMaybe<Scalars['Int']['input']>;
};

export type PolicyMetrics = {
  __typename?: 'PolicyMetrics';
  nonTriggeredCorrectnessCount: Scalars['Int']['output'];
  nonTriggeredCorrectnessPercentage: Scalars['Float']['output'];
  overallCorrectnessCount: Scalars['Int']['output'];
  overallCorrectnessPercentage: Scalars['Float']['output'];
  policyId: Scalars['String']['output'];
  policyName: Scalars['String']['output'];
  triggeredCorrectnessCount: Scalars['Int']['output'];
  triggeredCorrectnessPercentage: Scalars['Float']['output'];
};

export type PolicySummaryMetrics = {
  __typename?: 'PolicySummaryMetrics';
  nonTriggeredPoliciesCorrectCount: Scalars['Int']['output'];
  nonTriggeredPoliciesCorrectPercentage: Scalars['Float']['output'];
  nonTriggeredPoliciesCount: Scalars['Int']['output'];
  totalPoliciesAssessed: Scalars['Int']['output'];
  triggeredPoliciesCorrectCount: Scalars['Int']['output'];
  triggeredPoliciesCorrectPercentage: Scalars['Float']['output'];
  triggeredPoliciesCount: Scalars['Int']['output'];
};

export type ProdPromptVersion = {
  __typename?: 'ProdPromptVersion';
  classification: Scalars['String']['output'];
  moderation: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  assignModerationCase: Array<Maybe<ModerationCase>>;
  auditDecisions: AuditDecisionsResponse;
  auditItems: AuditItemsResponse;
  auditSessionFilterOptions: AuditSessionFilterOptions;
  auditSessionStats?: Maybe<AuditSessionStats>;
  authProviders: AuthProvidersResponse;
  communities: CommunitiesResponse;
  community?: Maybe<Community>;
  communityGroup?: Maybe<CommunityGroup>;
  communityGroups: Array<CommunityGroup>;
  communityGroupsWithCommunities: CommunityGroupsWithCommunitiesResponse;
  communityModerationStats: Array<TopicStat>;
  communityOptions: CommunityOptions;
  communityPromptDetails: CommunityPromptDetailsResponse;
  communityPrompts?: Maybe<CommunityPrompt>;
  communityTestContent: TestContentResponse;
  conversationContext: ConversationContextResponse;
  currentUser?: Maybe<User>;
  customLabels: CustomLabelsResponse;
  isUserCommunityAdmin: Scalars['Boolean']['output'];
  isUserCommunityGroupAdmin: Scalars['Boolean']['output'];
  labelPolicyContent: LabelPolicyContent;
  metadataDiscovery: MetadataDiscoveryResponse;
  searchContent: ContentSearchResponse;
  session: Session;
  standardLabel: StandardLabelResponse;
  standardLabels: StandardLabelsResponse;
  standardPolicies: PoliciesResponse;
  standardPolicy: Policy;
  systemConfig: SystemConfig;
  topicModerationStats: TopicStat;
};


export type QueryAssignModerationCaseArgs = {
  communityId: Scalars['ID']['input'];
  topicName: Scalars['String']['input'];
};


export type QueryAuditDecisionsArgs = {
  input: AuditDecisionsInput;
};


export type QueryAuditItemsArgs = {
  input: AuditItemsInput;
};


export type QueryAuditSessionFilterOptionsArgs = {
  communityId: Scalars['ID']['input'];
};


export type QueryAuditSessionStatsArgs = {
  auditSessionId: Scalars['ID']['input'];
};


export type QueryCommunitiesArgs = {
  communityGroupId: Scalars['ID']['input'];
};


export type QueryCommunityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommunityGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommunityModerationStatsArgs = {
  communityId: Scalars['ID']['input'];
};


export type QueryCommunityPromptDetailsArgs = {
  communityId: Scalars['ID']['input'];
  input: GetCommunityPromptDetailsInput;
};


export type QueryCommunityPromptsArgs = {
  communityId: Scalars['ID']['input'];
};


export type QueryCommunityTestContentArgs = {
  communityId: Scalars['ID']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConversationContextArgs = {
  input: ContentSearchContextInput;
};


export type QueryCustomLabelsArgs = {
  communityId: Scalars['ID']['input'];
};


export type QueryIsUserCommunityAdminArgs = {
  communityId: Scalars['ID']['input'];
};


export type QueryIsUserCommunityGroupAdminArgs = {
  communityGroupId: Scalars['ID']['input'];
};


export type QueryLabelPolicyContentArgs = {
  filename?: InputMaybe<Scalars['String']['input']>;
  labelId: Scalars['ID']['input'];
};


export type QueryMetadataDiscoveryArgs = {
  input: MetadataDiscoveryInput;
};


export type QuerySearchContentArgs = {
  input: ContentSearchInput;
};


export type QueryStandardLabelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStandardPoliciesArgs = {
  input?: InputMaybe<GetStandardPoliciesInput>;
};


export type QueryStandardPolicyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTopicModerationStatsArgs = {
  communityId: Scalars['ID']['input'];
  topicName: Scalars['String']['input'];
};

export type ReportFilters = {
  __typename?: 'ReportFilters';
  auditorIds?: Maybe<Array<Scalars['String']['output']>>;
  communityId?: Maybe<Scalars['String']['output']>;
  timeframe?: Maybe<TimeRange>;
};

export type ReportMetrics = {
  __typename?: 'ReportMetrics';
  byCommunity?: Maybe<Array<CommunityMetrics>>;
  byLabel?: Maybe<Array<LabelMetrics>>;
  byPolicy?: Maybe<Array<PolicyMetrics>>;
  disagreements: DisagreementMetrics;
  labelComparison: LabelComparisonMetrics;
  overall: MetricsGroup;
  policySummary?: Maybe<PolicySummaryMetrics>;
};

export type SafetyAction = {
  __typename?: 'SafetyAction';
  deliverySettings?: Maybe<DeliverySettings>;
  deliveryType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<ActionLabel>>;
  name: Scalars['String']['output'];
  operatorName: Scalars['String']['output'];
  policies?: Maybe<Array<Scalars['ID']['output']>>;
  type?: Maybe<Scalars['String']['output']>;
  workflowType?: Maybe<Scalars['String']['output']>;
};

export type SampleFilters = {
  __typename?: 'SampleFilters';
  contentTypes?: Maybe<Array<Scalars['String']['output']>>;
  labelSeverities?: Maybe<Array<Scalars['Int']['output']>>;
  labels?: Maybe<Array<Scalars['String']['output']>>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  topics?: Maybe<Array<Scalars['String']['output']>>;
};

export type SampleParameters = {
  __typename?: 'SampleParameters';
  communityId: Scalars['String']['output'];
  filters: SampleFilters;
  samplingParameters: SamplingParameters;
};

export type SampleParametersInput = {
  communityId?: InputMaybe<Scalars['String']['input']>;
  filters: SamplingFiltersInput;
  samplingParameters: SamplingParametersInput;
};

export type SampleStatistics = {
  __typename?: 'SampleStatistics';
  confidenceLevel: Scalars['Float']['output'];
  labelCounts?: Maybe<Array<CompositionEntry>>;
  languageCounts?: Maybe<Array<CompositionEntry>>;
  marginOfError: Scalars['Float']['output'];
  populationSize: Scalars['Int']['output'];
  sampleSize: Scalars['Int']['output'];
  topicCounts?: Maybe<Array<CompositionEntry>>;
};

export type SampleTimeframe = {
  __typename?: 'SampleTimeframe';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type SamplingFiltersInput = {
  contentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  labelSeverities?: InputMaybe<Array<Scalars['Int']['input']>>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SamplingParameters = {
  __typename?: 'SamplingParameters';
  confidenceLevel: Scalars['Float']['output'];
  marginOfError: Scalars['Float']['output'];
  populationProportion: Scalars['Float']['output'];
  timeframe: SampleTimeframe;
};

export type SamplingParametersInput = {
  confidenceLevel: Scalars['Float']['input'];
  marginOfError: Scalars['Float']['input'];
  populationProportion: Scalars['Float']['input'];
  timeframe: TimeRangeInput;
};

export type SecurityGroups = {
  __typename?: 'SecurityGroups';
  admin: Array<Scalars['String']['output']>;
  moderator: Array<Scalars['String']['output']>;
  user: Array<Scalars['String']['output']>;
};

export type SecurityGroupsInput = {
  admin?: InputMaybe<Array<Scalars['String']['input']>>;
  moderator?: InputMaybe<Array<Scalars['String']['input']>>;
  user?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SelectAuditDecisionInput = {
  auditItemId: Scalars['ID']['input'];
  auditSessionId: Scalars['ID']['input'];
  decisionId: Scalars['ID']['input'];
};

export type SelectAuditDecisionResponse = {
  __typename?: 'SelectAuditDecisionResponse';
  auditItem: AuditItemWithDecisions;
};

export type Session = {
  __typename?: 'Session';
  authenticated: Scalars['Boolean']['output'];
  providerId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type SessionMutationResponse = {
  __typename?: 'SessionMutationResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SkipAuditItemInput = {
  itemId: Scalars['ID']['input'];
};

export type SkipAuditItemResponse = {
  __typename?: 'SkipAuditItemResponse';
  item: AuditItem;
};

export type StandardLabel = {
  __typename?: 'StandardLabel';
  backupVersions: Array<Scalars['String']['output']>;
  contentType: ContentType;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  labelName: Scalars['String']['output'];
  labelNumMap: Scalars['Float']['output'];
  labelShortName: Scalars['String']['output'];
  labelStatus: Scalars['String']['output'];
  lastModifiedAt: Scalars['String']['output'];
  lastModifiedBy: Scalars['String']['output'];
  maxSeverity?: Maybe<Scalars['Float']['output']>;
  policy: Scalars['String']['output'];
  scope: LabelScope;
};

export type StandardLabelResponse = {
  __typename?: 'StandardLabelResponse';
  label: StandardLabel;
};

export type StandardLabelsResponse = {
  __typename?: 'StandardLabelsResponse';
  labels: Array<StandardLabel>;
};

export type SubjectOwner = {
  __typename?: 'SubjectOwner';
  additionalInfo?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SystemConfig = {
  __typename?: 'SystemConfig';
  mediaServiceUrl?: Maybe<Scalars['String']['output']>;
};

export type TestContentResponse = {
  __typename?: 'TestContentResponse';
  promptVersion: Scalars['String']['output'];
  samples: Array<TestContentSample>;
};

export type TestContentSample = {
  __typename?: 'TestContentSample';
  content: Scalars['String']['output'];
  expectedHarmful: Scalars['Boolean']['output'];
  explanation: Scalars['String']['output'];
  potentialHarmCategories: Array<Scalars['String']['output']>;
};

export type TimeRange = {
  __typename?: 'TimeRange';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type TimeRangeInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type TokenInput = {
  access_token: Scalars['String']['input'];
  expires_in: Scalars['Float']['input'];
  ext_expires_in?: InputMaybe<Scalars['Float']['input']>;
  id_token?: InputMaybe<Scalars['String']['input']>;
  refresh_token: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
  token_type: Scalars['String']['input'];
};

export type Topic = {
  __typename?: 'Topic';
  humanModerationAssignedTtlInSeconds: Scalars['Float']['output'];
  humanModerationCasesSlaInSeconds: Scalars['Float']['output'];
  maxCasesPerModerator: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type TopicAction = {
  __typename?: 'TopicAction';
  actionNames: Array<Scalars['String']['output']>;
  topicName: Scalars['String']['output'];
};

export type TopicActionInput = {
  actionNames: Array<Scalars['String']['input']>;
  topicName: Scalars['String']['input'];
};

export type TopicStat = {
  __typename?: 'TopicStat';
  assignedCasesCount: Scalars['Float']['output'];
  communityId: Scalars['String']['output'];
  inSLACases: Scalars['Float']['output'];
  nearSLACases: Scalars['Float']['output'];
  openCasesCount: Scalars['Float']['output'];
  outOfSLACases: Scalars['Float']['output'];
  topicName: Scalars['String']['output'];
};

export type UnskipAuditItemInput = {
  itemId: Scalars['ID']['input'];
};

export type UpdateCommunityGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  securityGroups?: InputMaybe<SecurityGroupsInput>;
};

export type UpdateCommunityInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  optionalMetadata?: InputMaybe<OptionalMetadataInput>;
  securityGroups?: InputMaybe<SecurityGroupsInput>;
};

export type UpdateCustomLabelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  labelType?: InputMaybe<LabelType>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLabelPolicyContentResponse = {
  __typename?: 'UpdateLabelPolicyContentResponse';
  labelId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  policyFile: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdatePolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<PolicyLabelInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  workflowType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePromptProdVersionInput = {
  version: Scalars['String']['input'];
};

export type UpdatePromptProdVersionResponse = {
  __typename?: 'UpdatePromptProdVersionResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateStandardLabelInput = {
  contentType?: InputMaybe<ContentType>;
  labelName?: InputMaybe<Scalars['String']['input']>;
  labelNumMap?: InputMaybe<Scalars['Float']['input']>;
  labelShortName?: InputMaybe<Scalars['String']['input']>;
  labelStatus?: InputMaybe<Scalars['String']['input']>;
  policy?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<LabelScopeInput>;
};

export type UpdateStandardPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<PolicyLabelInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  sourcePolicyId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertActionInput = {
  deliverySettings?: InputMaybe<DeliverySettingsInput>;
  deliveryType: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  operatorName?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  workflowType?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertAuditDecisionInput = {
  auditItemId: Scalars['ID']['input'];
  auditSessionId: Scalars['ID']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  correctedLabels?: InputMaybe<Array<AuditLabelInput>>;
  correctedOcr?: InputMaybe<Scalars['String']['input']>;
  correctedTranscription?: InputMaybe<Scalars['String']['input']>;
  existingDecisionId?: InputMaybe<Scalars['ID']['input']>;
  labelsCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  languageCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  nonTriggeredPolicyAssessments?: InputMaybe<Array<PolicyCorrectnessAssessmentInput>>;
  ocrCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  originalLabels: Array<AuditLabelInput>;
  policiesCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  shouldDelete?: InputMaybe<Scalars['Boolean']['input']>;
  transcriptionCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  triggeredPolicyAssessments?: InputMaybe<Array<PolicyCorrectnessAssessmentInput>>;
};

export type UpsertAuditDecisionResponse = {
  __typename?: 'UpsertAuditDecisionResponse';
  auditItem: AuditItemWithDecisions;
  auditItemId: Scalars['String']['output'];
  auditSessionId: Scalars['String']['output'];
  auditorId: Scalars['String']['output'];
  auditorName: Scalars['String']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  correctedLabels: Array<AuditLabel>;
  correctedOcr?: Maybe<Scalars['String']['output']>;
  correctedTranscription?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isCurrentUser: Scalars['Boolean']['output'];
  isSelected: Scalars['Boolean']['output'];
  labelsCorrect?: Maybe<Scalars['Boolean']['output']>;
  languageCorrect?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedAt: Scalars['String']['output'];
  lastModifiedBy: Scalars['String']['output'];
  nonTriggeredPolicyAssessments?: Maybe<Array<PolicyCorrectnessAssessment>>;
  ocrCorrect?: Maybe<Scalars['Boolean']['output']>;
  originalLabels: Array<AuditLabel>;
  policiesCorrect?: Maybe<Scalars['Boolean']['output']>;
  selectedAt?: Maybe<Scalars['String']['output']>;
  selectedBy?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  transcriptionCorrect?: Maybe<Scalars['Boolean']['output']>;
  triggeredPolicyAssessments?: Maybe<Array<PolicyCorrectnessAssessment>>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type UpsertCommunityGroupWorkflowConfigurationInput = {
  topicActions: Array<TopicActionInput>;
};

export type UpsertCommunityWorkflowConfigurationInput = {
  apiSettings: ApiSettingsInput;
  topicActions: Array<TopicActionInput>;
};

export type UpsertTopicInput = {
  humanModerationAssignedTtlInSeconds?: InputMaybe<Scalars['Int']['input']>;
  humanModerationCasesSlaInSeconds?: InputMaybe<Scalars['Int']['input']>;
  maxCasesPerModerator?: InputMaybe<Scalars['Int']['input']>;
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
};

export type WorkflowConfiguration = {
  __typename?: 'WorkflowConfiguration';
  topicActions: Array<TopicAction>;
  type: Scalars['String']['output'];
};
